import { AnyAction } from "redux";
import { LOADING_REMOVE, LOADING_ADD } from "./actionTypes";
import { LoadingState } from "../../../../models/state";

const initialState: LoadingState = {
    pending: [],
};

const reducer = (state = initialState, action: AnyAction): LoadingState => {
    switch (action.type) {
        case LOADING_ADD:
            return {
                ...state,
                pending: [...state.pending, action.actionType],
            };
        case LOADING_REMOVE:
            return {
                ...state,
                pending: state.pending.filter((elem) => elem !== action.actionType),
            };
        default:
            return state;
    }
};

export default reducer;
